"use client";

import { Image as ImageType } from "@/types/Image";
import { useEffect, useRef, useState } from "react";
import LeftArrow from "../icons/LeftArrow";
import ButtonIcon from "../utils/ButtonIcon";
import Modal from "../utils/Modal";
import Album from "./Album";
import AlbumCarouselModal from "./AlbumCarouselModal";
import "./index.scss";

const AlbumModal = ({
  images,
  initialImageIndex,
  onClose,
}: {
  images: ImageType[];
  initialImageIndex: number;
  onClose: () => void;
}) => {
  const [isAlbumCarouselModalOpened, setIsAlbumCarouselModalOpened] =
    useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const albumComponentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (albumComponentRef && albumComponentRef.current) {
      albumComponentRef.current.children[initialImageIndex].scrollIntoView();
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        if (isAlbumCarouselModalOpened === false) {
          onClose();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isAlbumCarouselModalOpened, onClose]);

  const openAlbumCarouselModal = (imageIndex: number) => {
    setSelectedImageIndex(imageIndex);
    setIsAlbumCarouselModalOpened(true);
  };

  return (
    <Modal>
      <div className="component album-modal">
        <div className="modal-header">
          <ButtonIcon onClick={onClose} aria-label="Close">
            <LeftArrow />
          </ButtonIcon>
        </div>
        <div className="modal-body">
          <Album
            images={images}
            onClick={openAlbumCarouselModal}
            ref={albumComponentRef}
          />
        </div>
      </div>

      {isAlbumCarouselModalOpened && (
        <AlbumCarouselModal
          images={images}
          initialImageIndex={selectedImageIndex}
          onClose={() => {
            setIsAlbumCarouselModalOpened(false);
          }}
        />
      )}
    </Modal>
  );
};

export default AlbumModal;
